export default __webpack_public_path__ + "static/media/promo.bdedde7e.png";